import {Configuration} from "./base-api";
import {environment} from "../../environments/environment";

export function apiConfigFactory() {

  return new Configuration({
    basePath: environment.apiUrl,
  });
}
